module.exports = __webpack_public_path__ + "static/IsabellaKurniaLiemMDPhD-5431a6bc60b6c12832803548074f5b4c.jpg";